<div class="container-fluid px-0 d-print-block" [class.d-none]="!useRouting">
    <!-- <div class="text-right pb-2">
    <img [src]="'assets/logos-big/' + tenant + '.svg?v=1'" class="tenant-logo" [alt]="tenant" />
  </div> -->

    <ng-container *ngIf="showSection('job')">
        <h2
            class="text-left border rounded border-dark pl-2"
            [translate]="title"
        ></h2>
        <div class="row">
            <div class="col-4 pre-wrap">{{ asTextBlock() }}</div>
            <div class="col-4">
                <img
                    [src]="'assets/logos-big/' + tenant + '.svg?v=1'"
                    class="tenant-logo"
                    [alt]="tenant"
                />
            </div>
            <div class="col-4">
                <dl class="row px-0">
                    <dt class="col-4" translate="Job.Date"></dt>
                    <dd class="col-8">: {{ job?.nextAction | date }}</dd>

                    <dt class="col-4" translate="Job.Logged"></dt>
                    <dd class="col-8">: {{ job?.logged | date }}</dd>

                    <dt class="col-4" translate="Job.JobID"></dt>
                    <dd class="col-8">: {{ job?.jobId }}</dd>

                    <dt class="col-4" translate="Job.TypeID"></dt>
                    <dd class="col-8">
                        :
                        <span
                            [abiLookupdisplayValue]="job?.typeId"
                            listName="CodeJobType"
                        ></span>
                    </dd>

                    <dt class="col-4" translate="Job.Status"></dt>
                    <dd class="col-8">
                        :
                        <span
                            [abiLookupdisplayValue]="job?.statusId"
                            listName="CodeJobStatus"
                        ></span>
                    </dd>
                </dl>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="showSection('tech')">
        <h4
            class="text-left border rounded border-dark pl-2"
            translate="Job.Resource"
        ></h4>
        <div class="row">
            <div class="col">
                <dl class="row px-0">
                    <dt class="col-4" translate="Job.Resource"></dt>
                    <dd class="col-8">: {{ resource?.code }}</dd>

                    <dt class="col-4" translate="Contact.Company"></dt>
                    <dd class="col-8">: {{ resource?.contact?.companyName }}</dd>

                    <ng-container *hasTranslation="'ResourceContact.Telephone'">
                        <dt class="col-4" translate="Contact.Telephone"></dt>
                        <dd class="col-8">
                            : {{ resource?.contact?.officeHours }}
                        </dd>
                    </ng-container>
                </dl>
            </div>
            <div class="col">
                <dl class="row px-0">
                    <dt class="col-4" translate="Contact.Name"></dt>
                    <dd class="col-8">: {{ resource?.contact | contact }}</dd>

                    <ng-container *hasTranslation="'ResourceContact.Email'">
                        <dt class="col-4" translate="Contact.Email"></dt>
                        <dd class="col-8 line-wrap">
                            : {{ resource?.contact?.emailAddress }}
                        </dd>
                    </ng-container>
                </dl>
            </div>
        </div>
    </ng-container>

    <!-- <h4 class="text-center border rounded border-dark">{{ 'Job.Customer' | translate }} / {{ 'Job.Dealer' | translate }}</h4> -->
    <div class="row">
        <div class="col-8">
            <h4 class="text-left border rounded border-dark pl-2">
                {{ "Job.Customer" | translate }}
            </h4>
        </div>
        <div class="col-4">
            <h4 class="text-left border rounded border-dark pl-2">
                {{ "Job.Dealer" | translate }}
            </h4>
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            {{ job?.contact | contact }}
            <br />
            <span class="pre-wrap"> {{ job?.address | address }}</span>
        </div>

        <div class="col-4">
            <dl class="row px-0">
                <ng-container *ngIf="showField('Contact.OfficeHours')">
                    <dt class="col-4" translate="Contact.OfficeHours"></dt>
                    <dd class="col-8">: {{ job?.contact?.officeHours }}</dd>
                </ng-container>

                <ng-container *ngIf="showField('Contact.AfterHours')">
                    <dt class="col-4" translate="Contact.AfterHours"></dt>
                    <dd class="col-8">: {{ job?.contact?.afterHours }}</dd>
                </ng-container>

                <ng-container *ngIf="showField('Contact.Mobile')">
                    <dt class="col-4" translate="Contact.Mobile"></dt>
                    <dd class="col-8">: {{ job?.contact?.mobile }}</dd>
                </ng-container>

                <ng-container *ngIf="showField('Contact.Email')">
                    <dt class="col-4" translate="Contact.Email"></dt>
                    <dd class="col-8 line-wrap">: {{ job?.contact?.emailAddress }}</dd>
                </ng-container>

                <ng-template [ngIf]="job?.ourRef">
                    <dt class="col-4">&nbsp;</dt>
                    <dd class="col-8">&nbsp;</dd>
                    <dt class="col-4" translate="Job.OurReference"></dt>
                    <dd class="col-8">: {{ job?.ourRef }}</dd>
                </ng-template>
            </dl>
        </div>

        <div class="col-4">
            <dl class="row px-0">
                <dt class="col-4" translate="Contact.Name"></dt>
                <dd class="col-8">: {{ job?.dealerContact | contact }}</dd>

                <dt class="col-4" translate="Contact.Company"></dt>
                <dd class="col-8">: {{ job?.dealerContact?.companyName }}</dd>

                <dt class="col-4" translate="Contact.OfficeHours"></dt>
                <dd class="col-8">: {{ job?.dealerContact?.officeHours }}</dd>

                <dt class="col-4" translate="Contact.Mobile"></dt>
                <dd class="col-8">: {{ job?.dealerContact?.mobile }}</dd>

                <dt class="col-4" translate="Contact.Email"></dt>
                <dd class="col-8 line-wrap">: {{ job?.dealerContact?.emailAddress }}</dd>
            </dl>
        </div>
    </div>


    <ng-container *ngIf="showSection('machine')">
        <h4
            class="text-left border rounded border-dark pl-2"
            translate="Job.Machine"
        ></h4>
        <div class="row">
            <div class="col-4">
                <dl class="row px-0">
                    <dt class="col-4" translate="Job.Machine"></dt>
                    <dd class="col-8">: {{ model?.code }}</dd>

                    <dt class="col-4" translate="Machine.MachineName"></dt>
                    <dd class="col-8">: {{ job?.machine?.name }}</dd>

                    <ng-container *hasTranslation="'Machine.Field1'">
                        <dt class="col-4" translate="Machine.Field1"></dt>
                        <dd class="col-8">: {{ job?.machine?.fields?.[0] }}</dd>
                    </ng-container>

                    <ng-container *hasTranslation="'Machine.Field2'">
                        <dt class="col-4" translate="Machine.Field2"></dt>
                        <dd class="col-8">: {{ job?.machine?.fields?.[1] }}</dd>
                    </ng-container>
                    <ng-container *hasTranslation="'Machine.Field3'">
                        <dt class="col-4" translate="Machine.Field3"></dt>
                        <dd class="col-8">: {{ job?.machine?.fields?.[2] }}</dd>
                    </ng-container>
                    <ng-container *hasTranslation="'Machine.Field4'">
                        <dt class="col-4" translate="Machine.Field4"></dt>
                        <dd class="col-8">: {{ job?.machine?.fields?.[3] }}</dd>
                    </ng-container>
                </dl>
            </div>
            <div class="col-4">
                <dl class="row px-0">
                    <dt class="col-4" translate="Machine.Serial"></dt>
                    <dd class="col-8">: {{ job?.machine?.serialNumber }}</dd>

                    <dt class="col-4" translate="Machine.DateOfPurchase"></dt>
                    <dd class="col-8">
                        : {{ job?.machine?.dateOfPurchase | date }}
                    </dd>
                    <dt class="col-4" translate="Machine.BranchID"></dt>
                    <dd class="col-8">
                        :
                        <span
                            [abiLookupdisplay]="job?.machine?.dealerBranchId"
                            listName="DealerBranch"
                        ></span>
                    </dd>

                </dl>
            </div>
            <div class="col-4">
                <dl class="row px-0">
                    <dt class="col-4" translate="Machine.Category1"></dt>
                    <dd class="col-8">
                        :
                        <span
                            [abiLookupdisplayValue]="model?.categories?.[0]"
                            listName="CodeMachineCategory"
                        ></span>
                    </dd>
                    <dt class="col-4" translate="Machine.Category2"></dt>
                    <dd class="col-8">
                        :
                        <span
                            [abiLookupdisplayValue]="model?.categories?.[1]"
                            listName="CodeMachineCategory"
                        ></span>
                    </dd>

                    <dt class="col-4" translate="Machine.Category3"></dt>
                    <dd class="col-8">
                        :
                        <span
                            [abiLookupdisplayValue]="model?.categories?.[2]"
                            listName="CodeMachineCategory"
                        ></span>
                    </dd>

                    <ng-container *hasTranslation="'Job.CustomerReference'">
                        <dt class="col-4" translate="Job.CustomerReference"></dt>
                        <dd class="col-8">:{{ job?.customerRef }}</dd>
                    </ng-container>
                </dl>
            </div>
        </div>
    </ng-container>

    <div class="row">
        <div class="col">
            <h4
                class="text-left border rounded border-dark pl-2"
                translate="Job.FaultCodes"
            ></h4>
        </div>

        <div class="col-4" *ngIf="showSignature && showSection('signature'); else showExtras">
            <h4
                class="text-left border rounded border-dark pl-2"
                translate="Job.Signatures"
            ></h4>
        </div>
        <ng-template #showExtras>
            <div class="col-4">
                <h4
                class="text-left border rounded border-dark pl-2"
                >Extras</h4>
            </div>
        </ng-template>
    </div>

    <div class="row">
        <div class="col">
            <dl class="row px-0">
                <dt class="col-4" translate="Job.FaultDescription"></dt>
                <dd class="col-8 pre-wrap">: {{ job?.faultDescription }}</dd>

                <dt class="col-4" translate="Job.FaultCodeID"></dt>
                <dd class="col-8">
                    :
                    <span
                        [abiLookupdisplayValue]="job?.faultCodeId"
                        listName="CodeJobFault"
                    ></span>
                </dd>

                <dt class="col-4" translate="Job.DiagnosticCodeID"></dt>
                <dd class="col-8">
                    :
                    <span
                        [abiLookupdisplayValue]="job?.diagnosticCodeId"
                        listName="CodeJobDiagnostic"
                    ></span>
                </dd>
                <dt class="col-4" translate="Job.CloseCodeID"></dt>
                <dd class="col-8">
                    :
                    <span
                        [abiLookupdisplayValue]="job?.repairCodeId"
                        listName="CodeJobClose"
                    ></span>
                </dd>
            </dl>
        </div>

        <div class="col-4" *ngIf="showSignature && showSection('signature'); else showExtras2">
            <dl class="border rounded border-dark">
                <dt class="col-12" translate="Job.CustomerSign"></dt>
                <dd class="col-12">
                    <ng-container *ngIf="signatureNameCustomer; else blankSig">
                            <img [src]="signatureFileCustomer" class="img-fluid" *ngIf="signatureFileCustomer; else noSigImg"/>
                            <ng-template #noSigImg>
                                <p><em>Approved</em></p>
                            </ng-template>
                        <span><small>{{ signatureNameCustomer }} - {{ signatureDateCustomer | date }}</small></span>
                    </ng-container>
                </dd>
            </dl>

            <dl class="border rounded border-dark">
                <dt class="col-12" translate="Job.ResourceSign"></dt>
                <dd class="col-12">&nbsp;<br/>&nbsp;</dd>
            </dl>
            <ng-template #blankSig>
                &nbsp;<br/>&nbsp;
            </ng-template>
        </div>

        <ng-template #showExtras2>
            <div class="col-4">
                <div class="row">
                    <ng-container *hasTranslation="'Job.Field1'">
                        <dt class="col-4" translate="Job.Field1"></dt>
                        <dd class="col-8">
                            :
                            {{ job?.field1 }}
                        </dd>
                    </ng-container>
                    <ng-container *hasTranslation="'Job.Field2'">
                        <dt class="col-4" translate="Job.Field2"></dt>
                        <dd class="col-8">
                            :
                            {{ job?.field2 }}
                        </dd>
                    </ng-container>
                    <ng-container *hasTranslation="'Job.Field3'">
                        <dt class="col-4" translate="Job.Field3"></dt>
                        <dd class="col-8">
                            :
                            {{ job?.field3 }}
                        </dd>
                    </ng-container>
                    <ng-container *hasTranslation="'Job.Field4'">
                        <dt class="col-4" translate="Job.Field4"></dt>
                        <dd class="col-8">
                            :
                            {{ job?.field4 }}
                        </dd>
                    </ng-container>
                    <ng-container *hasTranslation="'Job.Field5'">
                        <dt class="col-4" translate="Job.Field5"></dt>
                        <dd class="col-8">
                            :
                            {{ job?.field5 }}
                        </dd>
                    </ng-container>
                </div>
            </div>
        </ng-template>
    </div>

    <ng-container *ngIf="showSection('noteExternal')">
        <h4
            class="text-left border rounded border-dark pl-2"
            translate="Job.NoteExternal"
        ></h4>
        <div class="row">
            <div class="col">
                <dl class="row px-0">
                    <dt class="col-4" translate="Job.NoteExternal"></dt>
                    <dd class="col-8 pre-wrap">: {{ job?.noteExternal }}</dd>


                </dl>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="showLines && showSection('lines')">
        <h4
            class="text-left border rounded border-dark pl-2"
            translate="Job.Lines"
        ></h4>

        <table class="table table-sm">
            <thead>
                <tr>
                    <th translate="JobLine.LineID"></th>
                    <th translate="JobLine.TypeID"></th>
                    <th translate="JobLine.ItemID"></th>
                    <th translate="JobLine.Description"></th>
                    <th class="text-right" translate="JobLine.Quantity"></th>
                    <th class="text-right" translate="JobLine.Price"></th>
                    <th class="text-right" translate="JobLine.Amount"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let line of job?.lines">
                    <td>
                        <small>{{ line.lineId }}</small>
                    </td>
                    <td>
                        <small>{{ line.typeId }}</small>
                    </td>
                    <td>
                        <small>{{ line.itemId }}</small>
                    </td>
                    <td>
                        <small>{{ line.line1 }}</small>
                    </td>
                    <td class="text-right">
                        <small>{{ line.quantityOrdered }}</small>
                    </td>
                    <td class="text-right">
                        <small>{{ line.price | number: "1.2-2" }}</small>
                    </td>
                    <td class="text-right">
                        <small>{{ line | jobline: "amount" }}</small>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6" class="text-right">
                        <strong translate="JobLine.Total"></strong>
                    </td>
                    <td class="text-right">
                        <small>
                            <strong>{{ job | job: "totalAmount" }}</strong>
                        </small>
                    </td>
                </tr>
            </tfoot>
        </table>
    </ng-container>

    <ng-container *ngIf="showSection('journals')">
        <div class="page-break">
            <h4
                class="text-left border rounded border-dark pl-2"
                translate="Job.Journals"
            ></h4>

            <ng-container *hasTranslation="'Job.NoteExternal'">
                <dl class="row px-0" >
                    <dt class="col-4" translate="Job.NoteExternal"></dt>
                    <dd class="col-8 pre-wrap">: {{ job?.noteExternal }}</dd>
                </dl>
            </ng-container>

            <table class="table table-sm mb-0">
                <thead>
                    <tr>
                        <th class="w-narrow" translate="JobJournal.Date"></th>
                        <th class="w-narrow" translate="JobJournal.By"></th>
                        <th class="w-narrow" translate="JobJournal.TypeID"></th>
                        <th class="w-narrow" translate="JobJournal.From"></th>
                        <th class="w-narrow" translate="JobJournal.To"></th>
                        <th translate="JobJournal.Text"></th>
                    </tr>
                </thead>
            </table>

            <table class="table table-sm">
                <tbody>
                    <tr *ngFor="let journal of allJournals">
                        <td class="w-narrow">
                            <small class="text-truncate d-inline-block w-99">{{
                                journal.created | date: "y-MM-dd HH:mm"
                            }}</small>
                        </td>
                        <td class="w-narrow">
                            <small class="text-truncate d-inline-block w-99">{{
                                journal.by
                            }}</small>
                        </td>
                        <td class="w-narrow">
                            <small
                                class="text-truncate d-inline-block w-99"
                                [abiLookupdisplay]="journal.typeId"
                                listName="CodeJournalType"
                            ></small>
                        </td>
                        <td class="w-narrow">
                            <small class="text-truncate d-inline-block w-99">{{
                                journal.from
                            }}</small>
                        </td>
                        <td class="w-narrow">
                            <small class="text-truncate d-inline-block w-99">{{
                                journal.to
                            }}</small>
                        </td>
                        <td>
                            <small>{{ journal.text }}</small>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div *ngIf="showNotes">
                <h4
                    class="text-left border rounded border-dark pl-2"
                    translate="Job.Notes"
                ></h4>

                <table class="table table-sm">
                    <tbody>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

    </ng-container>
</div>
